<template>
    <v-card class="chart-card pa-0" height="100%">
        <div v-if="cleanTitle" class="chart-card-title" :title="cleanTitle">{{ cleanTitle }}</div>
        <v-card-text class="text-center chart-card-body">
            <apexchart ref="apex" type="bar" :height="height" :options="barOptions" :series="series" />
            <div class="chart-legend">
                <div v-for="(cat, i) in categories" :key="i" class="chart-legend-item">
                    <span class="chart-legend-color" :style="{ backgroundColor: colors[i % colors.length] }"></span>
                    <span class="chart-legend-label">{{ cat }}</span>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'
    import { captureWithLegend, COLORS } from './chartExportUtils'

    export default {

        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'categories', 'horizontal', 'distributed'],

        data() {
            return {
                colors: COLORS,
                barOptions: {
                    colors: COLORS,
                    chart: {
                        type: 'bar',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: true,
                        }
                    },
                    title: {
                        text: ''
                    },
                    legend: {
                        show: false
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            distributed: true
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        position: 'top',
                        style: {
                            colors: ['#fff']
                        },
                        dropShadow: {
                            enabled: true
                        }
                    },
                    stroke: {
                        show: false,
                        width: 2,
                    },
                    xaxis: {
                        categories: this.categories,
                        labels: {
                            labels: this.categories,
                            show: false
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            const labels = w.config.xaxis.labels.labels
                            if (seriesIndex !== 1 && labels && labels.length > dataPointIndex) {
                                const label = labels[dataPointIndex]
                                const value = series[seriesIndex][dataPointIndex]
                                return '<div style="padding:3px;font-weight:bold;color:white;background-color: #71BD48;">' + label + ': ' + value + '</div>'
                            }
                            return ''
                        }.bind(this)
                    },
                    fill: {
                        opacity: 1
                    },
                },
            }
        },

        computed: {
            cleanTitle() {
                return (this.title || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
            }
        },

        methods: {
            async capture() {
                try {
                    return await captureWithLegend(this.$refs.apex, this.categories || [])
                } catch (e) {
                    console.error('Bar capture failed', e)
                    return null
                }
            }
        }
    }
</script>

<style>
    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }

    .chart-legend {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px 16px;
        margin-top: 8px;
        padding: 0 8px 4px;
    }

    .chart-legend-item {
        display: flex;
        align-items: center;
        gap: 5px;
        font-family: 'Tajawal', sans-serif;
        font-size: 12px;
        color: #263238;
    }

    .chart-legend-color {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 2px;
        flex-shrink: 0;
    }

    .chart-legend-label {
        white-space: nowrap;
    }
</style>
